import $ from "jquery";

import Util from "../../services/util";
import Store from "../../services/store";

import BrandItem from "../../components/brand-item/brand-item.vue";
import Breadcrumb from "../../components/breadcrumb/breadcrumb.vue";
import NotFound from "../../components/not-found/not-found.vue";

export default {
  name: "Brands",

  created() {
    $("html, body").animate({ scrollTop: 0 }, 0);
    this.breadcrumb = JSON.parse(JSON.stringify(this.$route.meta.breadcrumb));
    document.title = this.brandsTitle;
    if (!this.store._id) return;

    this.fetchBrands();
  },

  destroyed() {
    Util.setTitle();
  },

  components: {
    BrandItem,
    Breadcrumb,
    NotFound,
  },

  methods: {
    fetchBrands() {
      this.loading = true;
      return Store.getBrands(this.store._id)
        .then((x) => {
          this.brands = x.data || [];
          this.brands.sort((a, b) =>
            (a.name || "").localeCompare(b.name || "")
          );
          this.loading = false;
        })
        .catch((e) => {
          console.log(e);
          this.loading = false;
        });
    },
  },

  computed: {
    store() {
      return this.$store.state.storeInfo;
    },

    brandsTitle() {
      return this.store.brandsTitle || "Shop by brand";
    },
  },

  data() {
    return {
      breadcrumb: [],
      loading: false,
      brands: [],
    };
  },
};
